import React, { useState } from 'react'
import { Alert, Button, Form } from 'react-bootstrap'
import Modal from '@severed-links/common.modal'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { contactDetails, contactMessage, contactUrl } from './returningPlayerContactLinks'

const ReturningPlayerContact = ({ player, seasonName, onClose }) => {
  const details = contactDetails(player)
  const [channel, setChannel] = useState(details.email ? 'email' : 'sms')
  const [subject, setSubject] = useState(`Redherrings Football${seasonName ? ` ${seasonName}` : ''}: playing this year?`)
  const [message, setMessage] = useState(contactMessage(player, seasonName))
  const [copied, setCopied] = useState(false)
  const apple = /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent)
  const href = contactUrl({ channel, recipient: details[channel], subject, message, apple })

  return (
    <Modal show heading={`Contact ${player.fullName || `${player.firstName || ''} ${player.lastName || ''}`.trim()}`}
      onClose={onClose} showFooter={false}>
      <Form.Group controlId='returning-player-channel' className='mb-3'>
        <Form.Label>Send via</Form.Label>
        <Form.Select value={channel} onChange={e => setChannel(e.target.value)}>
          <option value='email' disabled={!details.email}>Email{!details.email ? ' (unavailable)' : ''}</option>
          <option value='sms' disabled={!details.sms}>SMS text{!details.sms ? ' (unavailable)' : ''}</option>
        </Form.Select>
      </Form.Group>
      <Form.Group controlId='returning-player-recipient' className='mb-3'>
        <Form.Label>To</Form.Label>
        <Form.Control readOnly value={details[channel] || 'No valid contact information recorded'} />
      </Form.Group>
      {channel === 'email' ?
        <Form.Group controlId='returning-player-subject' className='mb-3'>
          <Form.Label>Subject</Form.Label>
          <Form.Control value={subject} maxLength={200} onChange={e => setSubject(e.target.value)} />
        </Form.Group>
      : null}
      <Form.Group controlId='returning-player-message' className='mb-3'>
        <Form.Label>Message</Form.Label>
        <Form.Control as='textarea' rows={5} value={message} maxLength={1600}
          onChange={e => { setMessage(e.target.value); setCopied(false) }} />
      </Form.Group>
      <Alert variant='info'>Review and send in your own email or text app. If it does not open or include the message, copy the message below.</Alert>
      <div className='d-flex flex-wrap gap-2'>
        <Button href={href || undefined} disabled={!href}>Open {channel === 'email' ? 'email' : 'text'} app</Button>
        <CopyToClipboard text={message} onCopy={(text, success) => setCopied(success)}>
          <Button variant='light' disabled={!message.trim()}>{copied ? 'Copied' : 'Copy message'}</Button>
        </CopyToClipboard>
        <Button variant='light' onClick={onClose}>Close</Button>
      </div>
    </Modal>
  )
}

export default ReturningPlayerContact
